var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiAvatar from '@material-ui/core/Avatar';
import { styled } from '@material-ui/core/styles';
import { compose, sizing, shadows } from '@material-ui/system';
var StyledAvatar = styled(MuiAvatar)(compose(sizing, shadows));
var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["xs"] = "20px";
    AvatarSizes["sm"] = "40px";
    AvatarSizes["md"] = "70px";
    AvatarSizes["lg"] = "120px";
    AvatarSizes["xl"] = "180px";
})(AvatarSizes || (AvatarSizes = {}));
/**
 * Kareo wrapped component of the Material-UI Avatar. The prop API has been limited to props defined in AvatarProps.
 *
 * Material-UI Avatar: [Docs](https://v4.mui.com/components/avatars/), [API](https://v4.mui.com/api/avatar/)
 *
 * @storybook: [Avatar](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-avatar--avatar-main)
 */
var Avatar = React.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, disableElevation = _a.disableElevation, props = __rest(_a, ["size", "disableElevation"]);
    var width = AvatarSizes[size];
    return (React.createElement(StyledAvatar, __assign({}, props, { width: width, height: width, boxShadow: disableElevation ? 0 : 3, ref: ref })));
});
Avatar.displayName = 'KareoAvatar';
export default Avatar;
